import React from 'react';

import './log-row.styles.scss';

const LogRow = ({data}) => {

    return (
        <tr className='log-row-1'>
        
        
            <td className='data-text log-names'>
                {data.Id}
            </td>
            <td className='data-text log-type'>
                {data.Action}
            </td>

            <td className='data-text log-description'>
                {data.Note}
            </td>

            <td className='data-text log-address'>
                {data.Ip}
            </td>

            <td className='data-text log-creator'>
                {data.UserId}
            </td>

            <td className='data-text log-created-date'>
                {data.Created}
            </td>
            
        </tr>
    )
}

export default LogRow;
